/**
 * BUSINESS LOGIC: BONGO CAM OVERLAY
 */
import { 
    GetBongoConfig as DLGetBongoConfig,
    SetBongoConfig as DLSetBongoConfig,
    ShowBongoOverlay as DLShowBongoOverlay,
    HideBongoOverlay as DLHideBongoOverlay,
    TriggerBongoHit as DLTriggerBongoHit,
    TriggerBongoMode as DLTriggerBongoMode
} from './../DL/Bongo'

export const GetBongoConfig = async () => {
    return await DLGetBongoConfig();
};

export const SetBongoConfig = async (config) => {
    // Validaciones de rangos
    if (config.scale < 0.1) config.scale = 0.1;
    if (config.bpm < 30) config.bpm = 30;
    if (config.bpm > 300) config.bpm = 300;
    if (config.shapeOpacity < 0) config.shapeOpacity = 0;
    if (config.shapeOpacity > 1) config.shapeOpacity = 1;

    return await DLSetBongoConfig(config);
};

export const ShowBongoOverlay = async () => {
    return await DLShowBongoOverlay();
};

export const HideBongoOverlay = async () => {
    return await DLHideBongoOverlay();
};

export const TriggerBongoHit = async (side) => {
    return await DLTriggerBongoHit(side);
};

export const TriggerBongoMode = async (level) => {
    return await DLTriggerBongoMode(level);
};
